/*
 * Keeps the reading result in sync when the quiz lives on the same page.
 *
 * First paint is handled by the inline resolver in the section, which reads the
 * URL and localStorage before the browser paints. This file only covers what
 * happens afterwards: the visitor finishing the quiz without a page load.
 */
(function () {
  'use strict';

  var BANDS = ['depleted', 'low', 'threshold', 'adequate', 'good', 'optimal'];

  function applyReading(root, band, readingAt) {
    // An r1 value can arrive from a URL someone typed. Only the six known
    // bands ever reach the DOM, and even then as an attribute, never as text.
    var index = BANDS.indexOf(band);
    if (index === -1) return;

    root.hidden = false;
    root.dataset.band = band;
    root.style.setProperty('--sl-bar-col-you', String(index + 1));

    var marker = root.querySelector('[data-bar-marker="you"]');
    if (marker) marker.hidden = false;

    var eyebrow = root.querySelector('[data-result-eyebrow]');
    if (eyebrow && readingAt) {
      var time = new Date(readingAt * 1000).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
      eyebrow.textContent = (root.dataset.eyebrow || 'Your reading') + ' · ' + time;
    }
  }

  document.addEventListener('bl:event-quiz:submitted', function (event) {
    var state = event.detail && event.detail.state;
    if (!state) return;

    var sections = document.querySelectorAll('[data-sl-id="sl-section-events-result-v1"]');
    if (!sections.length) return;

    Array.prototype.forEach.call(sections, function (root) {
      applyReading(root, state.reading1, state.reading1At);
    });

    // The quiz card is what the visitor is looking at, so the result has to
    // come to them rather than wait at the bottom of the page.
    var first = sections[0];
    if (first.hidden) return;
    requestAnimationFrame(function () {
      first.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  });
})();
